import { DocUserInterface } from '../interfaces/doc-user.interface';
import { ValidationCommentInterface } from '../interfaces/validation-comment.interface';

export class ValidationComment {
  /**
   * Id.
   */
  public id: number;

  /**
   * Comment content.
   */
  public content: string;

  /**
   * Creation Date.
   */
  public creationDate: Date;

  /**
   * Author.
   */
  public author: DocUserInterface;

  /**
   * ValidationComment constructor.
   *
   * @param data Data.
   */
  constructor(data: ValidationCommentInterface) {
    this.id = data.id;
    this.content = data.content;
    this.creationDate = data.created_at;
    this.author = data.author;
  }
}
